import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import ContentsModal from 'contents_modal';

import Const         from 'fw_const';
import Utils         from 'utils';
// -------------------------------------------------------

class ReportScore extends React.Component {
  render() {
    let report = this.props.detail.report;
    
    let insight = [];
    
    if( report.product_type == 'FEED' ){
      insight = [
        { id: 'insight1', columns: ['likes', 'comments', 'dm_message', 'saved'] },
        { id: 'insight2', columns: ['reach', 'impressions', 'score_home', 'score_discovery', 'score_profile', 'score_tag', 'score_etc'] },
        { id: 'insight3', columns: ['share', 'profile_active', 'profile_exlink', 'profile_access', 'profile_follow'] },
      ];
    }
    if( report.product_type == 'REELS' ){
      insight = [
        { id: 'insight1', columns: ['plays', 'likes', 'comments', 'dm_message', 'saved'] },
        { id: 'insight2', columns: ['first_plays', 'replay'] },
        { id: 'insight3', columns: ['share', 'profile_active', 'profile_exlink', 'profile_access', 'profile_follow'] },
      ];
    }
    if( report.product_type == 'STORY' ){
      insight = [
        { id: 'insight1', columns: ['reach', 'action_account', 'action_profile', 'action_interaction'] },
        { id: 'insight2', columns: ['likes', 'link_clicks', 'total_action', 'profile_active', 'profile_exlink', 'profile_access', 'profile_follow'] },
      ];
    }
    
    return (
      <div className="modal-item report-score-view">
        { Const.value.reportMst.map((c, ckey) => {
          return (
            <div key={ckey} className="report-insight-contents">
              <p>{c.name}</p>
              <div className="insight-item-contents">
                { Const.value.reportColumns.map((d, key) => {
                  if( c.id != d.parent ) return null;
                  
                  let value = report[d.id];
                  if( value == undefined || value == null ) value = 0;
                  
                  return (
                    <div key={key} className="insight-item">
                      <h6>{d.name}</h6>
                      <h3>{Utils.viewInt(value)}</h3>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ReportScore;